export async function collectSearchPages<T>(read: (cursor: string | null) => Promise<{ page: T[]; isDone: boolean; continueCursor: string }>, cancelled: () => boolean, progress: (count: number) => void): Promise<T[] | null> {
  const rows: T[] = [];
  let cursor: string | null = null;
  const seen = new Set<string>();
  for (let page = 0; page < 1000; page++) {
    if (cancelled()) return null;
    const result = await read(cursor);
    if (cancelled()) return null;
    rows.push(...result.page); progress(rows.length);
    if (result.isDone) return rows;
    if (seen.has(result.continueCursor)) throw new Error("Search could not complete. Please retry.");
    seen.add(result.continueCursor); cursor = result.continueCursor;
  }
  throw new Error("Search exceeded the safety limit. No complete result count or export is available.");
}
